import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {CerveauApp} from "./CerveauApp";

const questionsCount = 5;

export class Quiz {

  constructor(el, feedbackEl) {
    this.$el = $(el);
    this.$questionEl = null;
    this.$feedbackLeft = $(feedbackEl);
    this.selectAnswerCallback = null;
    this.quizCompletedCallback = null;
    this.showNextQuestionCallback = null;
    this.feedbackShownCallback = null;
    this.locked = false;

    this.score = {C: 0, S: 0};

    this.init();
    this.randomizeQuizQuestions();
  }

  randomizeQuizQuestions() {
    const allQuestionsOptionsCount = this.$el.find(`.question`).length;
    const options = Array.from({length: allQuestionsOptionsCount}, (value, index) => index + 1);
    const shuffledOptions = shuffle(options);
    this.selectedQuestions = shuffledOptions.slice(0, questionsCount);
    console.log("randomizeQuizQuestions", this.selectedQuestions);
    return this.selectedQuestions;
  }

  init() {
    gsap.set(this.$el.find(".question"), {autoAlpha: 0});
    gsap.set(this.$el.find(".feedback"), {autoAlpha: 0});
    this.$el.find(".option").on("click", (e) => this.selectAnswer(e));
  }

  showQuestion(id) {
    gsap.set(this.$el.find('.feedback'), {autoAlpha: 0})
    gsap.set(this.$el.siblings(".next-step"), {autoAlpha: 0})

    this.$questionEl = this.$el.find(`#question-${id}`);

    const tl = new gsap.timeline();
    tl.set(this.$questionEl.find(".option,.option img"), {autoAlpha: 1, scale: 1});
    tl.fromTo(this.$questionEl, {autoAlpha: 0}, {autoAlpha: 1});
    tl.add(() => {
      this.locked = false;
    })
  }

  showNextQuestion() {
    if (this.questionsAvailable()) {
      // There are some questions available, show next question
      const nextQuestion = this.selectedQuestions.shift()
      this.showQuestion(nextQuestion);
    } else {
      // There is no question to show, quiz has ended
      console.log("There is no question to show, quiz has ended. Shouldn't be there.")
    }
  }

  questionsAvailable() {
    return this.selectedQuestions.length >= 1;
  }

  selectAnswer(e) {
    if (this.locked) return;
    this.locked = true;

    const $answer = $(e.currentTarget);
    const optionId = $answer.data("index");
    const answerValue = $answer.data("value");
    const $otherOptions = this.$questionEl.find(`.option:not([data-index=${optionId}])`);

    // Update user score
    this.score[(answerValue.toUpperCase() === "C") ? "C" : "S"] += 1;

    app.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXselection.mp3", 1, true)

    const tl = new gsap.timeline();
    if (this.selectAnswerCallback) tl.add(() => this.selectAnswerCallback(answerValue));
    tl.to($otherOptions, {
      autoAlpha: 0,
      ease: "ease.in",
      duration: 0.5,
    })
    tl.to($answer.find("img"), {
      scale: 1.05,
      duration: 0.3,
      ease: "sine.inOut",
    }, "<")
    tl.to($answer, {
      autoAlpha: 0,
      scale: 0.75,
      duration: 0.5,
      ease: "back.in",
    }, "+=0.2")
    tl.to(this.$questionEl, {
      autoAlpha: 0,
      duration: 0.5,
    })
    tl.add(() => this.showFeedback(answerValue));
  }

  showFeedback(answerValue) {
    const questionId = this.getCurrentQuestionIndex();
    const $feedbackEl = this.$el.find(`.feedback[data-question-index='${questionId}'][data-value='${answerValue}']`);

    const tl = new gsap.timeline();

    tl.to($feedbackEl, {
      autoAlpha: 1,
      ease: "ease.in",
      duration: 0.5,
    })

    tl.add(() => {
      const canvas = (answerValue === "S") ? this.$feedbackLeft.find("#feedback-striatum") : this.$feedbackLeft.find("#feedback-cortex");
      const lottie = canvas.data("lottie");
      lottie.setFrame(0);
      lottie.play();
    }, "<");

    if (answerValue === "S") app.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXstriatum.mp3", 1, true)
    if (answerValue === "C") app.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXcortex.mp3", 1, true)

    tl.to(this.$feedbackLeft, {
      autoAlpha: 1,
      ease: "ease.in",
      duration: 0.5,
    }, "<")

    // Show pink mask under animation
    // if (!this.questionsAvailable()) {
    //   tl.set("#brainmaze-pink-overlay", {autoAlpha: 1});
    // }

    if (this.feedbackShownCallback) tl.add(() => this.feedbackShownCallback(answerValue));

    tl.to(this.$feedbackLeft, {
      autoAlpha: 0,
      ease: "ease.in",
      duration: 0.5,
    }, "+=3")

    tl.add(() => app.setAdditionalToolsVisibility(true, false), "-=1")

    const activeCTA = (this.questionsAvailable()) ? this.$el.siblings(".next-step.shake-dice") : this.$el.siblings(".next-step.goto-conclusion")
    const inactiveCTA = (this.questionsAvailable()) ? this.$el.siblings(".next-step.goto-conclusion") : this.$el.siblings(".next-step.shake-dice");

    tl.add(CerveauApp.bringInCTA(activeCTA))

    gsap.set(inactiveCTA, {autoAlpha: 0});

    if (this.questionsAvailable()) {
      if (this.showNextQuestionCallback) tl.add(() => this.showNextQuestionCallback(answerValue));
    } else {
      const scoreValue = this.score.C >= this.score.S ? "C" : "S";
      if (this.quizCompletedCallback) tl.add(() => this.quizCompletedCallback(scoreValue));
    }
  }

  getCurrentQuestionIndex() {
    return this.$questionEl?.data("index") || 0;
  }

  reset() {
    this.$questionEl = null;
    this.score.C = this.score.S = 0;

    this.randomizeQuizQuestions();

    gsap.set(this.$el.find('.feedback'), {autoAlpha: 0})
    gsap.set(this.$el.find('.question'), {autoAlpha: 0})
  }

}
